/* Catálogo KAT — datos compartidos (producto.html + ficha.html) */
  window.KAT_PRODUCTS = {
    lens: {
      name:'KAT LUNA', pill:'Arenero con cámara · 72L', accent:'#CF4538', cover:AB+'arenero-rona.png',
      sub:'Tu gato. En vivo. Desde donde estés.',
      tags:[['Cámara HD','t-azul'],['Anti-olores','t-amarillo'],['Multigato','t-coral']],
      now:'$1.799.999', was:'$2.299.999', save:'Ahorras $500.000 · 22% OFF + bono de lanzamiento',
      color:'Blanco', swatch:'#ffffff',
      medidas:'59.5 × 53 × 58 cm · 11 kg',
      short:'Arenera autolimpiante con cámara HD, luz UV esterilizadora y 72L de capacidad. Ideal para casas con uno o varios gatos.',
      gallery:[AB+'katluna1c.png',AB+'katluna2c.png',AB+'katluna3c.png',AB+'katluna4c.png',AB+'katluna5c.png',AB+'katluna6c.png',AB+'katluna7c.png?v=5',AB+'katluna8c.png',AB+'katluna9c.png',AB+'katluna10c.png'],
      feats:[['Cámara 1080P HD','Visión nocturna — ves a tu gato en vivo desde la app.'],['Esterilización UV','Mata bacterias, no solo esconde el olor.'],['72L · ultra silencioso','El más grande del Katálogo, menos de 35 dB.']],
      desc:'¿Varios gatos en casa? La app reconoce a cada uno por separado y lleva su propio control: cuánto pesa y cuántas veces va al baño cada quien. Así notas a tiempo cualquier cambio en su salud, sin levantarte del sofá. Se limpia solo después de cada uso y, con su cámara HD, los ves en vivo desde donde estés.',
      info:{
        lead:'Cámara HD, luz UV y autolimpieza. Esto es lo que la hace única:',
        highlights:[
          {ic:'📷', t:'Cámara 1080P HD', d:'Ves a tu gato en vivo desde la app, con visión nocturna y Wi-Fi.'},
          {ic:'🦠', t:'Luz UV esterilizadora', d:'Elimina bacterias de verdad, no solo esconde el olor.'},
          {ic:'📦', t:'Gran capacidad · 72L', d:'La más amplia del Katálogo, para gatos de 1 a 12 kg.'}
        ],
        listTitle:'Características principales',
        list:[
          'Autolimpieza después de cada uso',
          'App Tuya: ciclos, historial y alertas',
          'Identifica a cada gato (peso e idas al baño)',
          'Ultra silenciosa: menos de 35 dB',
          'Cambio de arena con un solo clic'
        ],
        specsTitle:'Especificaciones',
        specs:[
          ['Capacidad interna','72 litros'],
          ['Apto para gatos','1 kg – 12 kg'],
          ['Canasta de residuos','7 litros'],
          ['Nivel de ruido','Menos de 35 dB'],
          ['Cámara','1080P HD con visión nocturna'],
          ['Conectividad','Wi-Fi doble banda + App Tuya'],
          ['Esterilización','Luz UV + eliminador de olores'],
          ['Dimensiones del empaque','59.5 × 53 × 58 cm'],
          ['Peso del paquete','11 kg']
        ],
        bonusTitle:'🎁 Bono de lanzamiento',
        bonus:['2 bolsas de repuesto','1 eliminador de olores'],
        incluye:[
          '1 Arenero automático KAT LUNA · 72L',
          '2 bolsas de repuesto + 1 eliminador de olores',
          'Acceso a la app Tuya (cámara, estadísticas y alertas)',
          'Guía de instalación rápida'
        ],
        envios:[
          'Envío gratis a toda Colombia. Entrega en 2–5 días hábiles según ciudad.',
          'Cambios sin preguntas dentro de los 7 días posteriores a la entrega (en su empaque original y sin uso).',
          'Garantía de 12 meses.'
        ]
      },
      reviews:[
        {t:'Un excelente producto, lo llevo usando una semana y es genial, súper práctico. A mis gatitos bebé les encantó. 🐱', ago:'Hace 2 meses', stars:5, img:AB+'resenalens1.webp'},
        {t:'Excelente producto, calibró fácilmente. Instrucciones muy claras; la precisión del peso, la actividad, la esterilización y la app son de lujo. Muy buena alternativa y sobre todo los procesos automáticos: no más preocupación por tareas manuales (se acabó el estrés y el mal olor). ¡Gracias!', ago:'Hace 1 mes', stars:5, img:AB+'resenalens2.webp'},
        {t:'Fue muy fácil de instalar (venía armado) y el aplicativo es muy fácil e intuitivo. Tengo 2 michis: uno de 4,5 kg y otro de 6 kg; es muy justo para ellos, ojalá fuera un poco más grande, pero aun así lo usan sin problema. La limpieza de la arena es perfecta, no la desperdicia y almacena los restos en su contenedor trasero. El tapete que trae ayuda a recoger la arena que sacan en sus patitas. Me encanta que no es ruidoso y que lleva registro de la hora exacta en que se acercan los michis, cuánto pesan, cuánto duraron en el baño y a qué hora salen. Llevo 2 días con él y estamos muy satisfechos con la compra.', ago:'Hace 5 meses', stars:5, img:AB+'resenalens3.webp'},
        {t:'Es muy buena. Se pueden configurar muchas cosas desde la app para que lo haga automáticamente, sin necesidad de estar uno pendiente. Buen producto.', ago:'Hace 5 meses', stars:4, img:AB+'resenalens4.webp'},
        {t:'Súper silencioso, ni se escucha cuando hace el ciclo de limpieza. La instalación con la app fue facilísima, quedó lista en minutos.', ago:'Hace 1 mes', stars:5},
        {t:'Vale cada peso. Ya no limpio el arenero todos los días y la casa huele limpia. La luz UV me da mucha tranquilidad con la higiene.', ago:'Hace 5 meses', stars:5, img:AB+'resenalens5.webp'},
        {t:'Es enorme por dentro, mi gato grande entra sin problema. Llegó rápido y con todos los repuestos de regalo incluidos.', ago:'Hace 3 semanas', stars:4},
        {t:'La cámara con visión nocturna es lo máximo, veo a mi gata de madrugada. Ya se la recomendé a toda mi familia.', ago:'Hace 4 meses', stars:5},
        {t:'Pensé que a mi gato le costaría, pero entró desde el primer día. El cambio de arena con un solo clic es comodísimo.', ago:'Hace 2 semanas', stars:4}
      ]
    },
    orbit: {
      name:'KAT ASTRO', pill:'Arenero autolimpiante · 50L', accent:'#FFD87D', cover:AB+'arenero-galactico.png',
      sub:'Lo justo, sin complicaciones.',
      tags:[['App','t-azul'],['Autolimpieza','t-amarillo'],['Silencioso','t-lila']],
      now:'$1.499.999', was:'$1.899.999', save:'Ahorras $400.000 · 21% OFF',
      color:'Gris', swatch:'#8a8a8a',
      medidas:'50 × 53.6 × 66.2 cm · 8.5 kg',
      gallery:[AB+'katastro1c.png',AB+'katastro2c.png',AB+'katastro3c.png',AB+'katastro4c.png',AB+'katastro5c.png',AB+'katastro6c.png',AB+'katastro7c.png',AB+'katastro8c.png',AB+'katastro9c.png',AB+'katastro10c.png'],
      short:'Arenero automático de 50 L con autolimpieza, sensor de movimiento y control por app. Compacto, silencioso y compatible con arena aglomerante. Lo esencial, sin complicaciones.',
      feats:[['Se limpia solo','Sistema automático después de cada uso.'],['Sensor de movimiento','Detecta cuando tu gato sale y limpia.'],['Control por app','Programa y monitorea desde el celular.']],
      desc:'¿Quieres automatizar la limpieza sin gastar de más? El KAT ASTRO hace lo esencial muy bien: cada vez que tu gato sale, su sensor de movimiento activa la limpieza automática y separa los desechos de la arena limpia. Con 50 litros hay espacio de sobra —incluso para varios gatos—, funciona en silencio (menos de 35 dB) y lo controlas todo desde la app. Compacto, moderno y mucho más práctico que una caja tradicional.',
      info:{
        lead:'Autolimpieza, sensor de movimiento y app — lo esencial, sin complicaciones:',
        highlights:[
          {ic:'🔄', t:'Se limpia solo', d:'Sistema automático que separa los desechos después de cada uso, sin que muevas un dedo.'},
          {ic:'📱', t:'Control desde la app', d:'Programa la limpieza, actívala en remoto y supervisa todo desde tu celular.'},
          {ic:'📦', t:'50 litros · multigato', d:'Espacio amplio para gatos de todos los tamaños, incluso para casas con varios.'}
        ],
        listTitle:'Características principales',
        list:[
          'Sistema automático de limpieza después de cada uso',
          'Sensor de movimiento que detecta cuando tu gato sale',
          'Control total desde la app (programar, limpiar, supervisar)',
          'Capacidad amplia de 50 L · ideal para multigato',
          'Bandeja de desechos extraíble',
          'Compatible con arena aglomerante y otros tipos',
          'Funcionamiento silencioso: menos de 35 dB',
          'Diseño compacto, ideal para apartamentos'
        ],
        specsTitle:'Especificaciones',
        specs:[
          ['Capacidad total','50 litros'],
          ['Limpieza','Sistema automático tras cada uso'],
          ['Sensor','De movimiento (detecta la salida del gato)'],
          ['Conectividad','App: programar, limpiar y supervisar'],
          ['Bandeja de desechos','Extraíble'],
          ['Nivel de ruido','Menos de 35 dB'],
          ['Tipos de arena','Aglomerante y otros'],
          ['Diseño','Compacto'],
          ['Alimentación','Eléctrica']
        ],
        incluye:[
          '1 Arenero automático KAT ASTRO · 50 L',
          '1 rollo de bolsas de residuos (20 unidades)',
          'Bandeja de desechos extraíble',
          'Adaptador de corriente',
          'Manual de uso',
          'Acceso a la app (programación y monitoreo)'
        ]
      },
      reviews:[
        {t:'Después de años con areneros tradicionales, no vuelvo atrás. Tengo dos gatos y lo aceptaron desde el primer día; el espacio interior es amplio incluso para el más grande. La instalación fue muy sencilla. Se limpia solo después de cada uso y el compartimento sellado controla los olores increíble: ¡adiós al olor a gato! Desde la app monitoreo el uso y me avisa cuándo vaciar. Vaciar es rápido, la arena dura más limpia (se ahorra) y es tan silencioso que no molesta ni a los gatos ni a nosotros. Me facilitó muchísimo la vida, sobre todo teniendo más de un gato. Totalmente recomendable.', ago:'Hace 1 mes', stars:5, img:AB+'resenaastro1.jpg'},
        {t:'Justo lo que buscaba: se limpia solo y no gasté de más. Mi gato se adaptó en dos días.', ago:'Hace 1 mes', stars:5, img:AB+'resenaastro2.jpg'},
        {t:'Súper silencioso, ni se escucha cuando hace el ciclo. La app es muy fácil de usar.', ago:'Hace 3 semanas', stars:5, img:AB+'resenaastro3.jpg'},
        {t:'Espacioso, mis dos gatos lo usan sin problema. Buena compra por el precio.', ago:'Hace 2 meses', stars:4},
        {t:'La bandeja se saca fácil y vaciar es rapidísimo. Ya no limpio todos los días.', ago:'Hace 1 mes', stars:5},
        {t:'Llegó rápido y bien empacado. El sensor funciona perfecto, se detiene cuando se acerca.', ago:'Hace 2 semanas', stars:5},
        {t:'Muy buen arenero para empezar con lo automático. Compacto, cabe bien en mi apartamento.', ago:'Hace 4 meses', stars:4},
        {t:'Cumple lo que promete. Controlo todo desde el celular aunque no esté en casa.', ago:'Hace 1 mes', stars:5},
        {t:'Excelente relación calidad-precio. Mi michi quedó feliz y yo más tranquilo.', ago:'Hace 3 semanas', stars:5}
      ]
    },
    libre: {
      name:'KAT COSMOS', pill:'Arenero abierto · gatos grandes', accent:'#ABCBD8', cover:AB+'arenero-abierto-1.png',
      sub:'Entra fácil, sale feliz.',
      tags:[['Diseño abierto','t-rosa'],['Gatos grandes','t-coral'],['Autolimpieza','t-amarillo']],
      now:'$1.699.999', was:'$1.999.999', save:'Ahorras $300.000 · 15% OFF',
      color:'Blanco', swatch:'#ffffff',
      medidas:'50 × 42.5 × 54 cm · 8.5 kg',
      short:'Arenero automático de diseño abierto, con app Tuya, 5 sistemas de seguridad y vaciado con un botón. Ideal para gatos grandes o que no entran a cápsulas cerradas.',
      gallery:[AB+'katcosmos1c.png',AB+'katcosmos2c.png',AB+'katcosmos3c.png',AB+'katcosmos4c.png',AB+'katcosmos5c.png',AB+'katcosmos6c.png',AB+'katcosmos7c.png',AB+'katcosmos8c.png',AB+'katcosmos9c.png',AB+'katcosmos10c.png'],
      feats:[['Diseño abierto 360°','Entrada amplia: hasta los gatos grandes entran y se dan la vuelta.'],['5 sistemas de seguridad','Se detiene al instante si detecta a tu gato dentro.'],['Vaciado con un botón','Limpieza con un toque o desde la app Tuya.']],
      desc:'¿Tu gato es grande o le incomodan las cápsulas cerradas? El KAT COSMOS tiene una entrada abierta y amplia donde entra, se da la vuelta y sale sin estrés. Se limpia solo tres minutos después de cada uso, separa los grumos automáticamente y guarda los desechos en un cajón cerrado de 9L. Y con cinco sistemas de seguridad, se detiene al instante si detecta a tu gato dentro.',
      info:{
        lead:'Diseño abierto, autolimpieza y control desde el celular. Esto es lo que lo hace único:',
        highlights:[
          {ic:'🐾', t:'Diseño abierto 360°', d:'Entrada amplia y sin cúpula: hasta los gatos grandes entran y giran sin estrés.'},
          {ic:'🛡️', t:'5 sistemas de seguridad', d:'Se detiene al instante si detecta a tu gato dentro.'},
          {ic:'📱', t:'Control desde la app', d:'Limpieza remota, historial y estadísticas desde la app Tuya.'}
        ],
        listTitle:'Características principales',
        list:[
          'Limpieza automática 3 min después de cada uso',
          'Vaciado con un botón o desde la app',
          '5 sistemas de seguridad anti-accidentes',
          'Entrada amplia para gatos grandes o ansiosos',
          'Compatible con arena mineral y bentonita'
        ],
        specsTitle:'Especificaciones',
        specs:[
          ['Capacidad de arena','40 litros'],
          ['Cajón de residuos','9 litros'],
          ['Dimensiones','50 × 42.5 × 54 cm'],
          ['Peso','8.5 kg'],
          ['Material de la carcasa','PP / PC / ABS'],
          ['Conectividad','Wi-Fi + App Tuya / Smart Home'],
          ['Tipos de arena','Mineral y bentonita aglomerante'],
          ['Seguridad','5 sistemas (infrarrojo, antipinzamiento, Hall, corriente, engranaje)']
        ],
        incluye:[
          '1 Arenero abierto KAT COSMOS',
          '1 rollo de bolsas de residuos (20 unidades)',
          'Adaptador de corriente',
          'Manual de instrucciones',
          'Acceso a la app Tuya (limpieza remota, historial y estadísticas)'
        ],
        envios:[
          'Envío gratis a toda Colombia. Entrega en 2–5 días hábiles según ciudad.',
          'Cambios sin preguntas dentro de los 7 días posteriores a la entrega (en su empaque original y sin uso).',
          'Garantía de 12 meses.'
        ]
      },
      reviews:[
        {t:'Mi gato JAMÁS entró a una cápsula cerrada. Este arenero abierto le encantó desde el primer día.', ago:'Hace 2 semanas', stars:5},
        {t:'Espacioso para mi gato grandote, entra y se da la vuelta sin problema. La limpieza automática me cambió la rutina.', ago:'Hace 3 semanas', stars:5},
        {t:'Me da tranquilidad lo de los sensores de seguridad: se detiene apenas se acerca. Muy buen producto.', ago:'Hace 1 mes', stars:5},
        {t:'El vaciado con un botón es comodísimo. Sacas la bolsa y listo, sin ensuciarte.', ago:'Hace 1 mes', stars:4},
        {t:'Perfecto para gatos ansiosos. El mío odiaba sentirse encerrado y con este quedó feliz.', ago:'Hace 2 meses', stars:5},
        {t:'Silencioso y fácil de configurar con la app. Llegó rápido a Medellín.', ago:'Hace 3 semanas', stars:5},
        {t:'Buen tamaño y se ve elegante. La bandeja cerrada controla muy bien el olor.', ago:'Hace 5 meses', stars:4},
        {t:'Vale la pena. Ya no batallo con la pala todos los días y mi gato lo usa sin drama.', ago:'Hace 1 mes', stars:5}
      ]
    },
    flow: {
      name:'KAT FLOW', pill:'Fuente de agua · 1.5–2 L', accent:'#FDA8BB', cover:AB+'fuente-prop.png',
      sub:'Siempre fresca, siempre limpia.',
      tags:[['Hidratación','t-rosa'],['Filtro 4-en-1','t-amarillo'],['Silenciosa','t-lila']],
      now:'$159.999', was:'$219.999', save:'Ahorras $60.000 · 27% OFF',
      color:'Gris oscuro', swatch:'#4a4a4a',
      medidas:'15.5 × 18 × 13 cm',
      short:'Fuente de agua de 1.5–2 L con filtración 4 en 1, agua en movimiento y sensor de nivel con apagado automático. Recarga superior, silenciosa y fácil de limpiar.',
      gallery:[AB+'katflow1c.png',AB+'katflow2c.png',AB+'katflow3c.png',AB+'katflow4c.png',AB+'katflow5c.png',AB+'katflow6c.png',AB+'katflow7c.png',AB+'katflow8c.png',AB+'katflow9c.png',AB+'katflow10c.png'],
      feats:[['Filtración 4 en 1','El agua deja de saber a vasija vieja.'],['Agua en movimiento','Tu gato bebe más; menos problemas urinarios.'],['Sensor de nivel','Se apaga solo y protege la bomba.']],
      desc:'¿Tu gato casi no toma agua? El KAT FLOW lo soluciona: el agua en movimiento lo invita a beber más, y su filtración en 4 etapas (malla, algodón, carbón activado y resina iónica) la mantiene limpia, fresca y sin malos olores. El sensor de nivel apaga la bomba cuando falta agua para protegerla, la recargas por arriba sin desmontar nada y es tan silenciosa que ni se nota. Más hidratación, menos problemas urinarios.',
      info:{
        lead:'Agua limpia, fresca y en movimiento — esto es lo que la hace única:',
        highlights:[
          {ic:'💧', t:'Filtración 4 en 1', d:'Malla, algodón, carbón activado y resina iónica: agua mucho más pura y sin malos olores.'},
          {ic:'🌊', t:'Agua en movimiento', d:'El flujo continuo invita a tu gato a beber más y ayuda a prevenir problemas urinarios.'},
          {ic:'🔌', t:'Apagado automático', d:'El sensor de nivel detiene la bomba cuando falta agua y la protege.'}
        ],
        listTitle:'Características principales',
        list:[
          'Filtración en 4 etapas: malla, algodón, carbón activado y resina iónica',
          'Agua en movimiento que invita a beber más',
          'Sensor de nivel con apagado automático (protege la bomba)',
          'Recarga por la parte superior, sin desmontar',
          'Fácil de desmontar y lavar',
          'Funcionamiento silencioso (motor de bajo ruido)',
          'Diseño moderno y compacto, libre de BPA'
        ],
        specsTitle:'Especificaciones',
        specs:[
          ['Capacidad','1.5 – 2 litros aprox.'],
          ['Filtración','4 en 1 (malla, algodón, carbón activado, resina iónica)'],
          ['Seguridad','Sensor de nivel + apagado automático'],
          ['Recarga','Apertura superior, sin desmontar'],
          ['Voltaje','DC 12V · bajo consumo'],
          ['Material','Libre de BPA, seguro para mascotas'],
          ['Ruido','Motor silencioso'],
          ['Ideal para','Gatos y perros pequeños y medianos']
        ],
        incluye:[
          '1 Fuente de agua KAT FLOW (1.5–2 L)',
          '1 Filtro 4 en 1',
          'Adaptador de corriente (DC 12V)',
          'Manual de uso'
        ]
      },
      reviews:[
        {t:'Mi gata ahora toma mucha más agua. Se nota que le gusta el agua en movimiento.', ago:'Hace 1 mes', stars:5, img:AB+'resenaflow1.jpg'},
        {t:'El agua se mantiene fresca y limpia. El filtro hace la diferencia, ya no sabe a estancada.', ago:'Hace 3 semanas', stars:5, img:AB+'resenaflow2.jpg'},
        {t:'Súper silenciosa, ni se escucha la bomba. Fácil de armar y de limpiar.', ago:'Hace 2 meses', stars:5, img:AB+'resenaflow3.jpg'},
        {t:'Buena capacidad, no tengo que rellenarla a cada rato. Mis dos gatos la usan.', ago:'Hace 1 mes', stars:4},
        {t:'Llegó bien empacada y funcionando. Calidad muy buena por el precio.', ago:'Hace 2 semanas', stars:5},
        {t:'Le bajó la ansiedad por el agua a mi gato. Bebe más y se ve más sano.', ago:'Hace 4 meses', stars:5},
        {t:'Práctica y bonita. El sensor de nivel me da tranquilidad para que no se queme la bomba.', ago:'Hace 3 semanas', stars:4}
      ]
    },
    kronch: {
      name:'KAT KRONCH', pill:'Comedero automático · cámara HD · app', accent:'#B5B0D6', cover:AB+'comedero-prop.png',
      sub:'La hora de comer, resuelta.',
      tags:[['Cámara 1080P','t-azul'],['Tanque 5L','t-amarillo'],['Control app','t-lila']],
      now:'$499.999', was:'$899.999', save:'Ahorras $400.000 · 44% OFF',
      color:'Blanco', swatch:'#ffffff',
      medidas:'30 × 30 × 40 cm · 3 kg',
      short:'Comedero automático con cámara 1080P HD y visión nocturna, tanque de 5L y control total desde la app: programa hasta 12 comidas al día con porciones exactas y vigila a tu mascota en tiempo real.',
      gallery:[AB+'katkronch1c.png',AB+'katkronch2c.png',AB+'katkronch3c.png',AB+'katkronch4c.png',AB+'katkronch6c.png',AB+'katkronch5c.png',AB+'katkronch7c.png',AB+'katkronch8c.png',AB+'katkronch9c.png',AB+'katkronch10c.png'],
      feats:[['Cámara 1080P HD','Vigila a tu mascota en tiempo real, incluso de noche.'],['Porciones programables','Hasta 12 comidas al día desde la app.'],['Tanque de 5L','Hasta 30–45 días de alimento para un gato.']],
      desc:'¿Te toca salir y no sabes si tu gato comió? El KAT KRONCH lo resuelve: programas hasta 12 comidas al día con porciones exactas desde la app, y su cámara 1080P HD con visión nocturna te deja verlo y hablarle en tiempo real desde donde estés. Su tanque de 5L guarda alimento para 30–45 días, se conecta por WiFi dual (2.4 y 5 GHz) y está hecho en ABS de grado alimenticio, libre de BPA. La rutina de tu mascota, siempre puntual, aunque tú no estés.',
      info:{
        lead:'Aliméntalo a su hora y vigílalo desde tu celular — esto es lo que lo hace único:',
        highlights:[
          {ic:'📷', t:'Cámara 1080P HD', d:'Con visión nocturna: ves a tu mascota en tiempo real, incluso con poca luz.'},
          {ic:'🍽️', t:'Porciones programables', d:'Hasta 12 comidas al día y 99 porciones por comida, exactas y a su hora.'},
          {ic:'📱', t:'Control por app', d:'WiFi dual (2.4 y 5 GHz) y app Pet Zero / Tuya / Smart Life para Android e iOS.'}
        ],
        listTitle:'Características principales',
        list:[
          'Cámara 1080P HD con visión nocturna',
          'Tanque de 5L: hasta 30–45 días de alimento (gato) o 5–7 días (perro grande)',
          'Programa hasta 12 comidas al día, 99 porciones por comida',
          'Conexión WiFi dual de 2.4 GHz y 5 GHz, estable',
          'Tazón de acero inoxidable, fácil de limpiar',
          'Material ABS de grado alimenticio, libre de BPA',
          'Respaldo de batería: sigue funcionando aunque se vaya la luz'
        ],
        specsTitle:'Especificaciones',
        specs:[
          ['Capacidad','Tanque de 5 litros'],
          ['Cámara','HD 1080P con visión nocturna'],
          ['Conexión','WiFi dual 2.4 GHz y 5 GHz'],
          ['App','Pet Zero / Tuya / Smart Life (Android e iOS)'],
          ['Alimentación','Hasta 12 comidas/día · 99 porciones por comida'],
          ['Tipo de comida','Solo alimento seco'],
          ['Material','ABS grado alimenticio, libre de BPA'],
          ['Energía','Adaptador 110–240V (USB CC 5V 2A) + respaldo de pilas'],
          ['Tazón','Acero inoxidable extraíble'],
          ['Ideal para','Gatos, perros y mascotas pequeñas']
        ],
        incluye:[
          '1 Comedero automático KAT KRONCH (tanque 5L)',
          '1 Tazón de acero inoxidable',
          '1 Adaptador de corriente + cable USB',
          'Manual de uso',
          '(Las 3 pilas D de respaldo no vienen incluidas)'
        ]
      },
      reviews:[
        {t:'Le doy la comida a la hora exacta aunque no esté en casa. La app es muy fácil.', ago:'Hace 1 mes', stars:5},
        {t:'Las porciones salen perfectas, mi gato ya no come de más. Ideal para controlar el peso.', ago:'Hace 3 semanas', stars:5},
        {t:'No se traba la comida, cae siempre. Llevo un mes y funciona impecable.', ago:'Hace 2 meses', stars:5},
        {t:'Me salvó para los viajes. Programo y listo, come a su hora.', ago:'Hace 1 mes', stars:5},
        {t:'Buen diseño y fácil de limpiar. Cabe bastante alimento.', ago:'Hace 2 semanas', stars:4},
        {t:'Mi gato ya tiene su rutina puntual. Súper recomendado para los que trabajamos todo el día.', ago:'Hace 4 meses', stars:5},
        {t:'Funciona muy bien con la app, ajusto las porciones desde el celular. Vale la pena.', ago:'Hace 3 semanas', stars:4}
      ]
    }
  };
